
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { NavMenuItemType } from '../../../model/NavMenu.model';
import { withErrorBoundary } from "../../../shared-components/ErrorBoundary";
import { 
    Breadcrumb, BreadcrumbItem, Button, Icon, PageTitle
} from '../SpaAdminScope';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../../../root-redux/RootState';
import { UserMode, setTabCache } from '../redux/CacheHandler.redux';
import { setEditCampaignFlag } from '../redux/CampaignById.redux';
import { setCampaignFilters } from '../redux/CampaignList.redux';

interface ICampaignHeader {
    title: string | undefined,
    workflowName?: string| undefined,
    currentPage: number
}

const EditCampaignHeader: React.FC<ICampaignHeader> = (props: ICampaignHeader) => {

    const navigate = useNavigate();
    const dispatchApp = useDispatch<AppDispatch>();
    const cacheHandler = useSelector((state: RootState) => state.cacheHandler);
    const [selectedTab, setSelectedTab] = useState<string>(cacheHandler.tabCache);

    const _onNavMenuItemClick = (navMenuItemType: NavMenuItemType) => {
        navigate("/" + NavMenuItemType[navMenuItemType]);
    };

    const onCloseClick = () => {
        if(props.title === "Dataset")
        {
            setSelectedTab("datasetTab");
            dispatchApp(setTabCache("datasetTab"));
        }
        else
        {
            setSelectedTab("spaTab");
            dispatchApp(setTabCache("spaTab"));
            dispatchApp(setEditCampaignFlag(false));
            dispatchApp(setCampaignFilters({}));
        }
        _onNavMenuItemClick(NavMenuItemType.Configuration);
    };

    return (
        <>
            
            <Breadcrumb className='spa-workspace' tabIndex={0}>
                <BreadcrumbItem>
                    <button
                        type="button"
                        onKeyDown={e => e.key === "Enter" && _onNavMenuItemClick(NavMenuItemType.Home)}
                        style={{ color: "#0078D4", fontWeight: "400", backgroundColor: 'transparent', border: 0 }}
                        onClick={() => _onNavMenuItemClick(NavMenuItemType.Home)}
                    >
                        Home
                    </button>
                </BreadcrumbItem>
                <BreadcrumbItem>
                    <button
                        type="button"
                        onKeyDown={e => e.key === "Enter" && _onNavMenuItemClick(NavMenuItemType.Configuration)}
                        style={{ color: "#0078D4", fontWeight: "400", backgroundColor: 'transparent', border: 0 }}
                        onClick={() => {
                            dispatchApp(setCampaignFilters({}));
                            _onNavMenuItemClick(NavMenuItemType.Configuration);
                        }}
                    >
                        Configuration
                    </button>
                </BreadcrumbItem>
            </Breadcrumb>

            <div className='spa-workspace'>
                <div className='sticky-header spa-header-style' style={{ marginBottom: "20px" }}>
                    <PageTitle>
                    {props.title === "Dataset" ? (
                        <>
                            {cacheHandler.datasetCache?.mode === UserMode.CREATE ? 'Create New Dataset' : 'Edit Dataset'}
                            {props.workflowName && <span slot="active-title">{props.workflowName}</span>}
                        </>
                    ) : props.title === "Reassign" ? (
                        <>
                            {'Upload File for Bulk Reassignment'}
                        </>
                    ) : (
                        <>
                            {cacheHandler.campaignCache?.mode === UserMode.CREATE ? 'Create New Campaign' : 'Edit Campaign'}
                            {props.title && <span slot="active-title">{props.title}</span>}
                        </>
                    )}
                    </PageTitle>    
                </div>
            </div>

            <div className="workflow-cancel-button">
                <Button
                    appearance="link"
                    onClick={onCloseClick}
                >
                    <Icon
                        label="workflow-cancel-button"
                        name="calculatormultiply"
                        style={{ width: "24px", height: "24px" }}
                    />
                </Button>
            </div>
        </>
    );
}

export const CampaignHeader = withErrorBoundary("Campaign Header", EditCampaignHeader);